// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ln-0";